import { ORG_IDS } from "@/config/organisations";

export function validateInvoice(invoice, project) {
  const arr = [];

  // if due date is before the invoire date
  const invoiceDate = invoice.sentAt ? new Date(invoice.sentAt) : new Date();
  if (invoice.dueAt && invoiceDate && new Date(invoice.dueAt) < new Date(invoiceDate)) arr.push("Due date is before the invoice date");

  // if there is a french TVA on a selego invoice
  if (invoice.taxType === "FR 20%" && invoice.organisation_id === ORG_IDS.SELEGO) arr.push("French TVA on a Selego invoice");
  // if there is a dutch TVA on a collectif invoice
  if (invoice.taxType === "NL 21%" && invoice.organisation_id === ORG_IDS.LE_COLLECTIF) arr.push("Dutch TVA on a Le Collectif invoice");
  if (!invoice.taxType) arr.push("TVA details missing");

  if (!invoice.index) arr.push("Invoice number missing");

  // if there is no client infos
  if (!project.name) arr.push("Client name missing");
  if (!project.clientAddress) arr.push("Client's address missing");
  if (!project.clientVat) arr.push("Client's VAT missing");
  if (!project.clientSiret) arr.push("Client's SIREN missing");
  return arr;
}
